import Header from "../../components/Header/Header";
import { observer } from "mobx-react";
//import { ReactComponent as DownArrow } from "../../assets/images/svg/downarrow.svg";
import ApplyFilter from "../../components/Reports/ApplyFilter";
import RadioGroup from "../../components/Reports/RadioGroup";
import {
  exportDataMenu,
  LEDGER,
  ledgerReportTypeBillsData,
  ledgertimePeriodRadioBtnsData,
  ledgertimePeriodRadioBtnsDataDetailedView,
  oneDayDif,
  REPORTS_PAGE,
  segmentsData,
} from "../../utils/constants";
import { useEffect, useRef, useState } from "react";
import EmptyDerivatives from "../../components/EmptyDerivaties/EmptyDerivaties";
import emptyIcon from "../../assets/images/svg/empty.svg";
import Table3 from "../../components/Table3/Table3";
import Table from "../../components/Table2";
import Modal from "../../components/Modal";
import {
  commaSeperated,
  commaSeperated2,
  convertDateToObj,
  downloadPDFFile,
  exportExcel,
  getAsOfDate,
  getCurrentDate,
  getExcelNumData2,
  getLedgerExcelDate,
  getLedgerExcelDate2,
  getPrintDate,
  logEvents,
  padNumber,
  //printDocument,
  removeBracket,
  replaceComma,
  showDataWithRupeeDashOrZero,
  sortDateLedger,
  trackEventWithScreen,
} from "../../utils/functions";
import DatePicker2 from "../../components/Reports/DatePicker2";
//import PopupMenu from "../../components/PopupMenu/PopupMenu";
//import PdfTable from "../../components/PdfTable/PdfTable";
import { monthsData3 } from "../../utils/data";
import LoadingScreen from "../../components/LoadingScreen/LoadingScreen";
import loaderGIF from "../../assets/images/gifs/loaderGIF.gif";
import SortTable2 from "../../utils/Hooks/SortTable2";
import AuthStore from "../../store/AuthStore";
import UserStore from "../../store/UserStore";
import ReportsStore from "../../store/ReportsStore";
import { setCookie, getCookie } from "../../utils/cookie";
import OverflowingText from "../../components/OverflowingText/OverflowingText";
import PageTitle from "../../components/PageTitle/PageTitle";
import PageHeading from "../../components/PageHeading/PageHeading";
import ExportReportList from "../../components/AccessibleDropdown/ExportReportList";
import DropdownWithOptions from "../../components/Reports/UnrealisedGLReport/DropdownWithOptions";

const LedgerReport = observer(() => {
  const [timePeriod, setTimePeriod] = useState(
    ReportsStore.ledgerReportFilter.timePeriod,
  );
  const [reportType, setReportType] = useState(
    ReportsStore.ledgerReportFilter.reportType,
  );
  const [datePickerModalOpen, setDatePickerModalOpen] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState(
    ReportsStore.ledgerReportFilter.selectedAccount,
  );
  //const [allAccountsMenuOpen, setAllAccountsMenuOpen] = useState(false);
  const [selectedSegment, setSelectedSegment] = useState(
    ReportsStore.ledgerReportFilter.selectedSegment,
  );
  //const [segmentMenuOpen, setSegmentMenuOpen] = useState(false);
  const [snapshotModalHeader, setSnapshotModalHeader] = useState("");
  const [snapshotModalRowData, setSnapshotModalRowData] = useState([]);
  const [snapshotModalOpen, setSnapshotModalOpen] = useState(false);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  //const [niftyMenu, setNiftyMenu] = useState(false);
  const [initialFromDate, setInitialFromDate] = useState(null);
  const [initialToDate, setInitialToDate] = useState(null);
  const [resetedFromDate, setResetedFromDate] = useState(null);
  const [resetedToDate, setResetedToDate] = useState(null);
  const [filteredColumn, setFilteredColumn] = useState("narration");
  const [isAscendingForHeader, setIsAscendingForHeader] = useState(false);
  const [vertualRows, setVertualRows] = useState([]);
  const [sortClicked, setSortClicked] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isDownloading, setIsDownloading] = useState(false);

  //const exportRef2 = useRef(null);
  //const ref = useRef(null);
  const exportItemRefs = useRef([]);

  const userHydrated = UserStore.isHydrated;
  const ledgerFilter = ReportsStore.ledgerReportFilter;
  const viewData = ReportsStore.ledgerDetailedViewTableData;
  const rememberedLedgerData = ReportsStore.rememberLedgerDetailedData;

  // const onClickOutside = useCallback(() => {
  //   setNiftyMenu(false);
  // }, []);

  // useEffect(() => {
  //   const handleClickOutside = (event) => {
  //     if (exportRef2.current && !exportRef2.current.contains(event.target)) {
  //       onClickOutside && onClickOutside();
  //     }
  //   };
  //   document.addEventListener("click", handleClickOutside, true);
  //   return () => {
  //     document.removeEventListener("click", handleClickOutside, true);
  //   };
  // }, [onClickOutside]);

  const handleTimePeriodChange = (selectedTimePeriod) => {
    setTimePeriod(selectedTimePeriod);
  };

  const handleReportTypeChange = (selectedReportType) => {
    setReportType(selectedReportType);

    const as_of_date = getAsOfDate(UserStore.asOfDate);
    const dateObjofAsOfDate = new Date(as_of_date);
    let newFromdate;
    let formattedFromdate;
    if (selectedReportType === "snapshot") {
      newFromdate = new Date(dateObjofAsOfDate.getFullYear() - 1, 3, 1);
      formattedFromdate =
        newFromdate?.getFullYear() +
        "-" +
        padNumber(newFromdate?.getMonth() + 1) +
        "-" +
        padNumber(newFromdate?.getDate());

      setResetedFromDate(convertDateToObj(formattedFromdate));
      setResetedToDate(convertDateToObj(as_of_date));
    } else {
      newFromdate = new Date(
        dateObjofAsOfDate.getFullYear(),
        dateObjofAsOfDate.getMonth(),
        1,
      );
      formattedFromdate =
        newFromdate?.getFullYear() +
        "-" +
        padNumber(newFromdate?.getMonth() + 1) +
        "-" +
        padNumber(newFromdate?.getDate());

      setResetedFromDate(convertDateToObj(formattedFromdate));
      setResetedToDate(convertDateToObj(as_of_date));
    }
  };

  const getAccountsList = () => {
    if (
      UserStore?.selectedClientId !== "0" &&
      getCookie("isPrimary") === "false"
    ) {
      return ReportsStore?.allAccountsData?.[
        UserStore?.selectedClientId
      ]?.flat();
    } else {
      if (ReportsStore?.allAccountsData) {
        return Object?.values(ReportsStore?.allAccountsData)?.flat();
      }
    }
  };

  const instrumentNameCellRenderer2 = (_, data, key) => {
    return (
      <div className="transaction_date_cell">
        {data[key] ? `${commaSeperated2(data[key])}` : "-"}
      </div>
    );
  };

  const instrumentNameCellRenderer = (_, data, key) => {
    if (key === "chequeNo") {
      return (
        <div className="transaction_date_cell">
          {data[key] ? commaSeperated(data[key]) : "-"}
        </div>
      );
    }
    if (key === "voucherType") {
      return (
        <div
          style={{ fontFamily: "Encode Sans", color: "#00a651" }}
          className="transaction_date_cell"
        >
          <span>{data[key] || "-"}</span>
        </div>
      );
    }
    if (key === "paymentsinRs" || key === "receiptsinRs") {
      return (
        <div className="transaction_date_cell" style={{ whiteSpace: "nowrap" }}>
          {data[key] ? showDataWithRupeeDashOrZero(data[key], false) : "-"}
        </div>
      );
    }
    if (key === "cummulativeBalance") {
      const reg = /[()]/g;
      return (
        <div className="transaction_date_cell">
          {data[key]
            ? showDataWithRupeeDashOrZero(data[key].replace(reg, ""), false)
            : "-"}
        </div>
      );
    }
    if (key === "date") {
      const getDisplayDate = (data) => {
        if (!data) return;
        const newArr = data?.split("/");
        return newArr
          ? `${newArr[1]} ${monthsData3[Number(newArr[0]) - 1]} ${newArr[2]}`
          : data;
      };
      return (
        <div
          style={{ fontFamily: "Encode Sans" }}
          className="transaction_date_cell"
        >
          {data[key]
            ? data[key].includes("/")
              ? getDisplayDate(data[key].slice(0, 10))
              : data[key]
            : "-"}
        </div>
      );
    }
    if (key === "narration")
      return (
        <div
          className="transaction_date_cell"
          style={{ fontFamily: "Encode Sans " }}
        >
          {data[key] ? (
            <OverflowingText
              text={data[key]}
              width={document.documentElement.clientWidth > 1100 ? 200 : 100}
              buttonStyle={{ top: "-15px" }}
              tooltipStyle={{ top: "25px" }}
            />
          ) : (
            "-"
          )}
        </div>
      );
    if (key === "exchange")
      return (
        <div
          className="transaction_date_cell"
          style={{ fontFamily: "Encode Sans" }}
        >
          {data[key] || "-"}
        </div>
      );

    return <div className="transaction_date_cell">{data[key] || "-"}</div>;
  };

  const modalDateCellRenderer = (_, data, key) => {
    if (key === "date") {
      const getDisplayDate = (data) => {
        if (!data) return;
        const newArr = data?.split("/");
        return newArr
          ? `${newArr[1]} ${monthsData3[Number(newArr[0]) - 1]} ${newArr[2]}`
          : data;
      };
      return (
        <div className="modal_date_cell">
          {data[key]
            ? data[key].includes("/")
              ? getDisplayDate(data[key].slice(0, 10))
              : data[key]
            : "-"}
        </div>
      );
    }
  };

  const LedgerColumns = [
    {
      label: "Date",
      key: "date",
      sortable: true,
      width: "186px",
      cellRendererExcel: (data, row, key) => getLedgerExcelDate2(data, "-"),
      cellRenderer: instrumentNameCellRenderer,
      cellRendererPdf: (data, row, key) =>
        data ? getLedgerExcelDate(data) : "-",
    },
    {
      label: "Voucher Type",
      key: "voucherType",
      sortable: true,
      width: "186px",
      cellRenderer: instrumentNameCellRenderer,
      cellRendererPdf: (data, row, key) => (data ? data : "-"),
    },
    {
      label: "Exchange",
      key: "exchange",
      sortable: true,
      width: "186px",
      cellRenderer: instrumentNameCellRenderer,
      cellRendererPdf: (data, row, key) => (data ? data : "-"),
    },
    {
      label: "Narration",
      key: "narration",
      sortable: true,
      width: "220px",
      cellRenderer: instrumentNameCellRenderer,
      cellRendererPdf: (data, row, key) => (data ? data : "-"),
    },
    {
      label: "Cheque No",
      key: "chequeNo",
      sortable: true,
      width: "186px",
      cellRenderer: instrumentNameCellRenderer,
      cellRendererPdf: (data, row, key) =>
        data ? getExcelNumData2(data, false, 2) : "-",
    },
    {
      label: "Receipts",
      key: "receiptsinRs",
      sortable: true,
      width: "186px",
      cellRenderer: instrumentNameCellRenderer,
      cellRendererPdf: (data, row, key) =>
        data ? getExcelNumData2(replaceComma(data), false, 2) : "-",
    },
    {
      label: "Payments",
      key: "paymentsinRs",
      sortable: true,
      width: "186px",
      cellRenderer: instrumentNameCellRenderer,
      cellRendererPdf: (data, row, key) =>
        data ? getExcelNumData2(replaceComma(data), false, 2) : "-",
    },
    {
      label: "Cummulative Balance",
      key: "cummulativeBalance",
      sortable: true,
      width: "226px",
      cellRenderer: instrumentNameCellRenderer,
      cellRendererPdf: (data, row, key) =>
        data ? getExcelNumData2(replaceComma(data), false, 2) : "-",
    },
  ];

  const snapshotColumns = [
    {
      label: "Date",
      key: "date",
      sortable: true,
      width: "149px",
      cellRenderer: modalDateCellRenderer,
    },
    {
      label: "Exchange",
      key: "exchange",
      sortable: true,
      width: "140px",
      cellRenderer: instrumentNameCellRenderer,
    },
    {
      label: "Narration",
      key: "narration",
      sortable: true,
      minWidth: "157px",
      cellRenderer: instrumentNameCellRenderer,
    },
    {
      label: "Receipts in ₹",
      key: "receiptsinRs",
      sortable: true,
      width: "144px",
      cellRenderer: instrumentNameCellRenderer2,
    },
    {
      label: "Payments in ₹",
      key: "paymentsinRs",
      sortable: true,
      width: "151px",
      cellRenderer: instrumentNameCellRenderer2,
    },
  ];

  const SnapshotModalContent = observer(() => {
    useEffect(() => {
      setSnapshotModalRowData(ReportsStore.ledgerSnapshotAssetModalTableData);
      // eslint-disable-next-line
    }, [ReportsStore.ledgerSnapshotAssetModalTableData]);

    const handleSort = (key) => {
      if (
        arrData &&
        arrData?.every((val, i, arr) => val?.[key] === arr?.[0]?.[key])
      ) {
        return;
      } else {
        setKeyForOrdering({ key1: key });
      }
    };

    return (
      <div className="snapshot_content">
        <>
          {ReportsStore.ledgerSnapshotAssetModalTableDataLoader ? (
            <div className="ledger_popup_loader">
              <div className="modal_header">
                <p className="modal_heading">{snapshotModalHeader}</p>
              </div>
              <img className="loader_gif" src={loaderGIF} alt="loading..." />
            </div>
          ) : (
            <>
              <div className="modal_header">
                <p className="modal_heading">{snapshotModalHeader}</p>
              </div>
              {snapshotModalRowData?.length ? (
                <div className="snapshot_table_bg">
                  <div className="snapshot_table_wrapper">
                    <Table
                      data={arrData}
                      columns={snapshotColumns}
                      handleSort={handleSort}
                      sortKey={key1}
                      isAscending={isAscending}
                      tableClass="snapshot_table"
                    />
                  </div>
                </div>
              ) : (
                <div className="empty_state_for_valuation">
                  <EmptyDerivatives
                    image={emptyIcon}
                    message="You do not have any records to display"
                  />
                </div>
              )}
            </>
          )}
        </>
      </div>
    );
  });

  useEffect(() => {
    if (UserStore.isHydrated) {
      let as_of_date = getAsOfDate(UserStore.asOfDate);
      const asOfDate = getCookie("asOfDate");
      if (!getAsOfDate(UserStore.asOfDate) && asOfDate) as_of_date = asOfDate;
      const dateObjofAsOfDate = new Date(as_of_date);
      let newFromdate;
      let formattedFromdate;
      let newTodate;
      let formattedTodate;
      const currentQuarter = Math.floor(dateObjofAsOfDate.getMonth() / 3);
      const quarterStartDate = new Date(
        dateObjofAsOfDate.getFullYear(),
        currentQuarter * 3,
      );

      let newFromdate2;
      let formattedFromdate2;

      newFromdate2 = new Date(dateObjofAsOfDate.getFullYear() - 1, 3, 1);
      formattedFromdate2 =
        newFromdate2?.getFullYear() +
        "-" +
        padNumber(newFromdate2?.getMonth() + 1) +
        "-" +
        padNumber(newFromdate2?.getDate());

      setResetedFromDate(convertDateToObj(formattedFromdate2));
      setResetedToDate(convertDateToObj(as_of_date));

      switch (timePeriod) {
        case "this_month":
          newFromdate = new Date(
            dateObjofAsOfDate.getFullYear(),
            dateObjofAsOfDate.getMonth(),
            1,
          );
          formattedFromdate =
            newFromdate?.getFullYear() +
            "-" +
            padNumber(newFromdate?.getMonth() + 1) +
            "-" +
            padNumber(newFromdate?.getDate());

          setFromDate(convertDateToObj(formattedFromdate));
          setToDate(convertDateToObj(as_of_date));
          break;
        case "previous_month":
          newFromdate = new Date(
            dateObjofAsOfDate.getFullYear(),
            dateObjofAsOfDate.getMonth() - 1,
            1,
          );
          formattedFromdate =
            newFromdate?.getFullYear() +
            "-" +
            padNumber(newFromdate?.getMonth() + 1) +
            "-" +
            padNumber(newFromdate?.getDate());
          let dummyDateObj = new Date(as_of_date);
          let dummyTime = dummyDateObj?.setDate(1);
          newTodate = new Date(dummyTime - oneDayDif);
          formattedTodate =
            newTodate?.getFullYear() +
            "-" +
            padNumber(newTodate?.getMonth() + 1) +
            "-" +
            padNumber(newTodate?.getDate());

          setFromDate(convertDateToObj(formattedFromdate));
          setToDate(convertDateToObj(formattedTodate));
          break;
        case "current_year":
          newFromdate = new Date(
            `${
              dateObjofAsOfDate.getMonth() - 3 < 0
                ? dateObjofAsOfDate.getFullYear() - 1
                : dateObjofAsOfDate.getFullYear()
            }`,
            3,
          );
          formattedFromdate =
            newFromdate?.getFullYear() +
            "-" +
            padNumber(newFromdate?.getMonth() + 1) +
            "-" +
            padNumber(newFromdate?.getDate());

          setFromDate(convertDateToObj(formattedFromdate));
          setToDate(convertDateToObj(as_of_date));
          break;
        case "previous_year":
          newFromdate = new Date(
            `${
              dateObjofAsOfDate.getMonth() - 3 < 0
                ? dateObjofAsOfDate.getFullYear() - 2
                : dateObjofAsOfDate.getFullYear() - 1
            }`,
            3,
            1,
          );
          formattedFromdate =
            newFromdate?.getFullYear() +
            "-" +
            padNumber(newFromdate?.getMonth() + 1) +
            "-" +
            padNumber(newFromdate?.getDate());

          newTodate = new Date(
            `${
              dateObjofAsOfDate.getMonth() - 3 < 0
                ? dateObjofAsOfDate.getFullYear() - 1
                : dateObjofAsOfDate.getFullYear()
            }`,
            2,
            31,
          );
          formattedTodate =
            newTodate?.getFullYear() +
            "-" +
            padNumber(newTodate?.getMonth() + 1) +
            "-" +
            padNumber(newTodate?.getDate());

          setFromDate(convertDateToObj(formattedFromdate));
          setToDate(convertDateToObj(formattedTodate));
          break;
        case "this_quarter":
          newFromdate = quarterStartDate;
          formattedFromdate =
            newFromdate?.getFullYear() +
            "-" +
            padNumber(newFromdate?.getMonth() + 1) +
            "-" +
            padNumber(newFromdate?.getDate());

          setFromDate(convertDateToObj(formattedFromdate));
          setToDate(convertDateToObj(as_of_date));
          break;
        case "previous_quarter":
          const currentQuarterStartDate = quarterStartDate;
          const currentQuarterEndDate = new Date(
            quarterStartDate.getFullYear(),
            quarterStartDate.getMonth() + 2,
            0,
          );
          const previousQuarterStartDate = new Date(
            currentQuarterStartDate.getFullYear(),
            currentQuarterStartDate.getMonth() - 3,
          );
          const previousQuarterEndDate = new Date(
            currentQuarterEndDate.getFullYear(),
            currentQuarterEndDate.getMonth() - 1,
            0,
          );

          newFromdate = previousQuarterStartDate;
          formattedFromdate =
            newFromdate?.getFullYear() +
            "-" +
            padNumber(newFromdate?.getMonth() + 1) +
            "-" +
            padNumber(newFromdate?.getDate());

          newTodate = previousQuarterEndDate;
          formattedTodate =
            newTodate?.getFullYear() +
            "-" +
            padNumber(newTodate?.getMonth() + 1) +
            "-" +
            padNumber(newTodate?.getDate());

          setFromDate(convertDateToObj(formattedFromdate));
          setToDate(convertDateToObj(formattedTodate));
          break;
        default:
          break;
      }
    }
  }, [
    timePeriod,
    userHydrated,
    //  UserStore.isHydrated
  ]);

  useEffect(() => {
    if (UserStore.isHydrated) {
      window.scrollTo(0, 0);
      setLoading(false);
      AuthStore.updateLoadingFullScreen(true);
      ReportsStore.populateReportsData("ledger");
      ReportsStore.updateLedgerReportTypeFilter("snapshot");
    }
    const resetFilterToDefaultState = () => {
      ReportsStore.ledgerReportFilter = {
        timePeriod: "current_year",
        reportType: "snapshot",
        selectedAccount: {},
        selectedSegment: {
          title: "All",
          id: "1",
        },
      };
    };
    return () => {
      resetFilterToDefaultState();
    };
  }, [
    userHydrated,
    //  UserStore.isHydrated
  ]);

  useEffect(() => {
    if (UserStore.isHydrated) {
      setTimePeriod(ReportsStore.ledgerReportFilter.timePeriod);
      setReportType(ReportsStore.ledgerReportFilter.reportType);
      setSelectedSegment(ReportsStore.ledgerReportFilter.selectedSegment);
      setSelectedAccount(ReportsStore.ledgerReportFilter.selectedAccount);
      setTimePeriod(ReportsStore.ledgerReportFilter.timePeriod);
    }
  }, [
    ledgerFilter,
    userHydrated,
    //  ReportsStore.ledgerReportFilter, UserStore.isHydrated
  ]);

  const onApplyFilter = () => {
    setFilteredColumn("narration");
    ReportsStore.setLedgerData();
    setIsAscendingForHeader(false);
    ReportsStore.updateLedgerFilter(
      {
        timePeriod,
        reportType,
        selectedAccount,
        selectedSegment,
      },
      "applyfrom",
    );
  };
  const onClearFilter = () => {
    setFilteredColumn("narration");
    ReportsStore.setLedgerData();
    ReportsStore.updateLedgerFilter(
      {
        timePeriod: "current_year",
        reportType: "snapshot",
        selectedAccount: Object?.values(ReportsStore?.allAccountsData)?.flat()
          ?.length
          ? Object?.values(ReportsStore?.allAccountsData)?.flat()[0]
          : {},
        selectedSegment: {
          title: "All",
          id: "1",
        },
      },
      "clear",
    );
  };

  useEffect(() => {
    if (UserStore.isHydrated) {
      if (ReportsStore.allAccountsAPIcallstate === "success") {
        if (fromDate && toDate) {
          ReportsStore.updateTableDataLoader(true);
          ReportsStore.getDataForLedgerReport(
            `${fromDate?.date}/${fromDate?.month}/${fromDate?.year}`,
            `${toDate?.date}/${toDate?.month}/${toDate?.year}`,
            selectedSegment.id,
          );
        }
      }
    }
    // eslint-disable-next-line
  }, [ReportsStore.allAccountsAPIcallstate, UserStore.isHydrated]);

  useEffect(() => {
    if (fromDate && toDate && UserStore.isHydrated) {
      ReportsStore.updateTableDataLoader(true);
      ReportsStore.getDataForLedgerReport(
        `${fromDate?.date}/${fromDate?.month}/${fromDate?.year}`,
        `${toDate?.date}/${toDate?.month}/${toDate?.year}`,
        selectedSegment.id,
      );
    }
    // eslint-disable-next-line
  }, [ReportsStore.ledgerReportFilter, UserStore.isHydrated]);

  const ledgerReportId = "ledgerReportId";

  const handleSortForDetailed = (filterType) => {
    setFilteredColumn(filterType);
    setIsAscendingForHeader(!isAscendingForHeader);
    setSortClicked(true);
  };

  const setAsOfDateToLocalStorage = () => {
    if (getAsOfDate(UserStore.asOfDate)) {
      setCookie("asOfDate", getAsOfDate(UserStore.asOfDate));
    }
  };

  useEffect(() => {
    ReportsStore.updateTableDataLoader(true);
    setAsOfDateToLocalStorage();
    window.scrollTo(0, 0);
    document.addEventListener("scroll", () => {
      if (document.documentElement.scrollTop === 0) {
        setVertualRows(ReportsStore.ledgerDetailedViewTableData?.slice(0, 20));
      }
      if (
        document.documentElement.scrollHeight -
          document.documentElement.scrollTop +
          document.documentElement.clientHeight <
          2000 &&
        ReportsStore.ledgerDetailedViewTableData?.length
      ) {
        if (vertualRows) {
          setVertualRows((prev) => {
            if (prev) {
              return [
                ...prev,
                ...ReportsStore.ledgerDetailedViewTableData.slice(
                  prev?.length,
                  prev?.length + 20,
                ),
              ];
            }
          });
        }
      }
    });
    AuthStore.updateLoadingFullScreen(true);
    const resetFilterToDefaultState = () => {
      ReportsStore.ledgerReportFilter = {
        timePeriod: "current_year",
        reportType: "snapshot",
        selectedAccount: {},
        selectedSegment: {
          title: "All",
          id: "1",
        },
      };
    };

    return () => {
      ReportsStore.updateTableDataLoader(true);
      resetFilterToDefaultState();
      ReportsStore.updateAllAccountToDefault();
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    trackEventWithScreen({ eventName: REPORTS_PAGE, screenName: LEDGER });
    logEvents(REPORTS_PAGE, {
      screenName: LEDGER,
    });
  }, []);

  useEffect(() => {
    if (!selectedAccount) {
      setSelectedAccount(ReportsStore.ledgerReportFilter.selectedAccount);
    }
    // eslint-disable-next-line
  }, [ReportsStore.ledgerReportFilter.selectedAccount]);

  // const ExtractDataContent = () => {
  //   const exportExcelClick = () => {
  //     exportExcel({
  //       sheetname:
  //         ReportsStore.ledgerReportFilter.reportType === "snapshot"
  //           ? "Ledger - Snapshot Report"
  //           : "Ledger - Detailed view Report",
  //       customNameWithTime: getInitialfileName(),
  //       columns:
  //         ReportsStore.ledgerReportFilter.reportType === "snapshot"
  //           ? LedgerSnapshotColumns
  //           : LedgerColumns,
  //       data:
  //         (ReportsStore.ledgerReportFilter.reportType === "snapshot"
  //           ? ReportsStore.ledgerSnapshotRawData
  //           : ReportsStore.ledgerDetailedViewTableData) || [],
  //       reportDetails: {
  //         relatioshipManager: UserStore?.exportDetails?.find(
  //           (item) => item.role === "RM",
  //         )?.name,
  //         serviceManager: UserStore?.exportDetails?.find(
  //           (item) => item.role === "CXO",
  //         )?.name,
  //         date: getPrintDate(getAsOfDate(UserStore.asOfDate)),
  //         clientName:
  //           UserStore.getData === "fam"
  //             ? UserStore.userData?.family_name
  //             : UserStore.userData?.full_name,
  //       },
  //       excelName: `Ledger - ${
  //         reportType === "snapshot" ? "Snapshot" : "Detailed View"
  //       } Report - ${selectedAccount?.account_Name} - ${getCurrentDate()}`,
  //     });
  //   };

  //   const exportPdf = async () => {
  //     // printDocument(ledgerReportId, {
  //     //   width: 850,
  //     //   height: 850,
  //     //   name: `Ledger - ${
  //     //     reportType === "snapshot" ? "Snapshot" : "Detailed View"
  //     //   } Report - ${selectedAccount?.account_Name}`,
  //     // });
  //     if (isDownloading) return; // guard against double-click while already running
  //     setIsDownloading(true);
  //     try {
  //       await downloadPDFFile({
  //         headerName:
  //           ReportsStore.ledgerReportFilter.reportType === "snapshot"
  //             ? "Ledger - Snapshot Report"
  //             : "Ledger - Detailed view Report",

  //         fileId: ledgerReportId,
  //         name: `Ledger - ${
  //           reportType === "snapshot" ? "Snapshot" : "Detailed View"
  //         } Report - ${selectedAccount?.account_Name}`,
  //         familyOrClientName: selectedAccount.account_Name,
  //         columns:
  //           ReportsStore.ledgerReportFilter.reportType === "snapshot"
  //             ? LedgerSnapshotColumns
  //             : LedgerColumns,
  //         data:
  //           (ReportsStore.ledgerReportFilter.reportType === "snapshot"
  //             ? ReportsStore.ledgerSnapshotRawData
  //             : ReportsStore.ledgerDetailedViewTableData) || [],
  //       });
  //     } finally {
  //       setIsDownloading(false);
  //       setNiftyMenu(false);
  //     }
  //   };

  //   return (
  //     <>
  //       <div ref={ref} className="extract_data_container downloadPdf">
  //         <p className="export_data_text">Export Data</p>
  //         <ul className="listitem_container">
  //           <li
  //             onClick={() => {
  //               exportExcelClick();
  //               setNiftyMenu(false);
  //             }}
  //           >
  //             <div className="listitem_icon excel"></div> Export to Excel
  //           </li>
  //           <li
  //             onClick={() => {
  //               exportPdf();
  //               //setNiftyMenu(false);
  //             }}
  //           >
  //             <div className="listitem_icon pdf"></div> Export to PDF
  //           </li>
  //         </ul>
  //         {isDownloading && (
  //           <div className="popup_downloader">
  //             <img src={loaderGIF} alt="img" />
  //           </div>
  //         )}
  //       </div>
  //       <div></div>
  //     </>
  //   );
  // };

  const LedgerSnapshotColumns = [
    {
      label: "Activity in Your Account",
      key: "asset",
    },
    {
      label: "Amount (in Rs)",
      key: "assetVal",
      cellRendererPdf: (data, row, key) =>
        row.isHeader !== "1" ? getExcelNumData2(data, false, 2) : "",
    },
  ];

  const { isAscending, key1, arrData, setKeyForOrdering } = SortTable2(
    snapshotModalRowData,
    { key1: "date" },
    false,
  );

  const handleTimePeriodReset = () => {
    setFromDate(initialFromDate);
    setToDate(initialToDate);
  };

  useEffect(() => {
    if ((datePickerModalOpen, UserStore.isHydrated)) {
      setInitialFromDate(fromDate);
      setInitialToDate(toDate);
    }
    // eslint-disable-next-line
  }, [datePickerModalOpen, UserStore.isHydrated]);

  const getInitialfileName = () => {
    return `Ledger - ${
      reportType === "snapshot" ? "Snapshot" : "Detailed View"
    } Report_${selectedAccount.account_Name}`;
  };

  useEffect(() => {
    let rowData = ReportsStore.rememberLedgerDetailedData;
    if (rowData) {
      if (filteredColumn === "exchange" && !isAscendingForHeader) {
        ReportsStore.updateLedgerDetailsData(
          [...rowData]?.sort((a, b) =>
            b?.[filteredColumn].localeCompare(a?.[filteredColumn]),
          ),
        );
      }
      if (filteredColumn === "exchange" && isAscendingForHeader) {
        ReportsStore.updateLedgerDetailsData(
          [...rowData]
            ?.sort((a, b) =>
              b?.[filteredColumn].localeCompare(a?.[filteredColumn]),
            )
            .reverse(),
        );
      }
      if (filteredColumn === "narration" && !isAscendingForHeader) {
        ReportsStore.updateLedgerDetailsData(
          [...rowData]?.sort((a, b) =>
            b?.[filteredColumn].localeCompare(a?.[filteredColumn]),
          ),
        );
      }
      if (filteredColumn === "narration" && isAscendingForHeader) {
        ReportsStore.updateLedgerDetailsData(
          [...rowData]
            ?.sort((a, b) =>
              b?.[filteredColumn].localeCompare(a?.[filteredColumn]),
            )
            .reverse(),
        );
      }
      if (filteredColumn === "voucherType" && !isAscendingForHeader) {
        ReportsStore.updateLedgerDetailsData(
          [...rowData]?.sort((a, b) =>
            b?.[filteredColumn].localeCompare(a?.[filteredColumn]),
          ),
        );
      }
      if (filteredColumn === "voucherType" && isAscendingForHeader) {
        ReportsStore.updateLedgerDetailsData(
          [...rowData]
            ?.sort((a, b) =>
              b?.[filteredColumn].localeCompare(a?.[filteredColumn]),
            )
            .reverse(),
        );
      }
      if (filteredColumn === "cummulativeBalance" && isAscendingForHeader) {
        ReportsStore.updateLedgerDetailsData(
          [...rowData]?.sort(
            (a, b) =>
              Number(removeBracket(a?.[filteredColumn])) -
              Number(removeBracket(b?.[filteredColumn])),
          ),
        );
      }
      if (filteredColumn === "cummulativeBalance" && !isAscendingForHeader) {
        ReportsStore.updateLedgerDetailsData(
          [...rowData]
            ?.sort(
              (a, b) =>
                Number(a?.[filteredColumn]?.replaceAll(",", "")).toFixed(2) -
                Number(b?.[filteredColumn]?.replaceAll(",", "")).toFixed(2),
            )
            .reverse(),
        );
      }
      if (filteredColumn === "paymentsinRs" && isAscendingForHeader) {
        ReportsStore.updateLedgerDetailsData(
          [...rowData]?.sort(
            (a, b) =>
              Number(a?.[filteredColumn]?.replaceAll(",", "")).toFixed(2) -
              Number(b?.[filteredColumn]?.replaceAll(",", "")).toFixed(2),
          ),
        );
      }
      if (filteredColumn === "paymentsinRs" && !isAscendingForHeader) {
        ReportsStore.updateLedgerDetailsData(
          [...rowData]
            ?.sort(
              (a, b) =>
                Number(a?.[filteredColumn]?.replaceAll(",", "")).toFixed(2) -
                Number(b?.[filteredColumn]?.replaceAll(",", "")).toFixed(2),
            )
            .reverse(),
        );
      }
      if (filteredColumn === "receiptsinRs" && isAscendingForHeader) {
        ReportsStore.updateLedgerDetailsData(
          [...rowData]?.sort(
            (a, b) =>
              Number(a?.[filteredColumn]?.replaceAll(",", "")).toFixed(2) -
              Number(b?.[filteredColumn]?.replaceAll(",", "")).toFixed(2),
          ),
        );
      }
      if (filteredColumn === "receiptsinRs" && !isAscendingForHeader) {
        ReportsStore.updateLedgerDetailsData(
          [...rowData]
            ?.sort(
              (a, b) =>
                Number(a?.[filteredColumn]?.replaceAll(",", "")).toFixed(2) -
                Number(b?.[filteredColumn]?.replaceAll(",", "")).toFixed(2),
            )
            .reverse(),
        );
      }
      if (filteredColumn === "chequeNo" && isAscendingForHeader) {
        ReportsStore.updateLedgerDetailsData(
          [...rowData]?.sort(
            (a, b) =>
              Number(a?.[filteredColumn]?.replaceAll(",", "")).toFixed(2) -
              Number(b?.[filteredColumn]?.replaceAll(",", "")).toFixed(2),
          ),
        );
      }
      if (filteredColumn === "chequeNo" && !isAscendingForHeader) {
        ReportsStore.updateLedgerDetailsData(
          [...rowData]
            ?.sort(
              (a, b) =>
                Number(a?.[filteredColumn]?.replaceAll(",", "")).toFixed(2) -
                Number(b?.[filteredColumn]?.replaceAll(",", "")).toFixed(2),
            )
            .reverse(),
        );
      }
      if (filteredColumn === "date" && isAscendingForHeader) {
        ReportsStore.updateLedgerDetailsData(
          [...rowData]?.sort((a, b) => {
            let aa = sortDateLedger(a?.[filteredColumn]);
            let bb = sortDateLedger(b?.[filteredColumn]);
            return aa < bb ? -1 : aa > bb ? 1 : 0;
          }),
        );
      }
      if (filteredColumn === "date" && !isAscendingForHeader) {
        ReportsStore.updateLedgerDetailsData(
          [...rowData]
            ?.sort((a, b) => {
              let aa = sortDateLedger(a?.[filteredColumn]);
              let bb = sortDateLedger(b?.[filteredColumn]);
              return aa < bb ? -1 : aa > bb ? 1 : 0;
            })
            .reverse(),
        );
      }
    }
  }, [
    filteredColumn,
    isAscendingForHeader,
    // ReportsStore.rememberLedgerDetailedData,
    rememberedLedgerData,
  ]);

  useEffect(() => {
    setVertualRows(ReportsStore.ledgerDetailedViewTableData?.slice(0, 20));
  }, [
    viewData,
    //  ReportsStore.ledgerDetailedViewTableData
  ]);

  useEffect(() => {
    if (ReportsStore.ledgerDetailedViewTableData && !sortClicked) {
      setIsAscendingForHeader(true);
      setSortClicked(true);
    }
    // eslint-disable-next-line
  }, [ReportsStore.ledgerDetailedViewTableData]);

  return (
    <div>
      <PageTitle title={"Ledger Report"} />
      {AuthStore.isLoadingFullScreen || !UserStore.isHydrated || loading ? (
        <LoadingScreen />
      ) : (
        <>
          <Header type="reports" />
          <div className="reports_outer_main">
            <div className="margin_statement_header_container">
              <PageHeading headingClass="head" headingText="Ledger Report" />
              {/* <div ref={exportRef2}>
                <PopupMenu
                  position={{ top: "59px", right: "2px" }}
                  setOpen={setNiftyMenu}
                  open={niftyMenu}
                  MenuContent={ExtractDataContent}
                >
                  <div className="export_data_btn">
                    <p className="export_data_text">Export Data</p>
                    <div className="export_text_wrapper">
                      <p className="export_type">Excel</p>
                      <DownArrow />
                    </div>
                  </div>{" "}
                </PopupMenu>
              </div> */}

              <div className="reports-export-wrapper margin-report-export-wrapper">
                <ExportReportList
                  exportExcel={() => {
                    exportExcel({
                      sheetname:
                        ReportsStore.ledgerReportFilter.reportType ===
                        "snapshot"
                          ? "Ledger - Snapshot Report"
                          : "Ledger - Detailed view Report",
                      customNameWithTime: getInitialfileName(),
                      columns:
                        ReportsStore.ledgerReportFilter.reportType ===
                        "snapshot"
                          ? LedgerSnapshotColumns
                          : LedgerColumns,
                      data:
                        (ReportsStore.ledgerReportFilter.reportType ===
                        "snapshot"
                          ? ReportsStore.ledgerSnapshotRawData
                          : ReportsStore.ledgerDetailedViewTableData) || [],
                      reportDetails: {
                        relatioshipManager: UserStore?.exportDetails?.find(
                          (item) => item.role === "RM",
                        )?.name,
                        serviceManager: UserStore?.exportDetails?.find(
                          (item) => item.role === "CXO",
                        )?.name,
                        date: getPrintDate(getAsOfDate(UserStore.asOfDate)),
                        clientName:
                          UserStore.getData === "fam"
                            ? UserStore.userData?.family_name
                            : UserStore.userData?.full_name,
                      },
                      excelName: `Ledger - ${
                        reportType === "snapshot" ? "Snapshot" : "Detailed View"
                      } Report - ${selectedAccount?.account_Name} - ${getCurrentDate()}`,
                    });
                  }}
                  exportPdf={async () => {
                    // printDocument(ledgerReportId, {
                    //   width: 850,
                    //   height: 850,
                    //   name: `Ledger - ${
                    //     reportType === "snapshot" ? "Snapshot" : "Detailed View"
                    //   } Report - ${selectedAccount?.account_Name}`,
                    // });
                    if (isDownloading) return; // guard against double-click while already running
                    setIsDownloading(true);
                    try {
                      await downloadPDFFile({
                        headerName:
                          ReportsStore.ledgerReportFilter.reportType ===
                          "snapshot"
                            ? "Ledger - Snapshot Report"
                            : "Ledger - Detailed view Report",

                        fileId: ledgerReportId,
                        name: `Ledger - ${
                          reportType === "snapshot"
                            ? "Snapshot"
                            : "Detailed View"
                        } Report - ${selectedAccount?.account_Name}`,
                        familyOrClientName: selectedAccount.account_Name,
                        columns:
                          ReportsStore.ledgerReportFilter.reportType ===
                          "snapshot"
                            ? LedgerSnapshotColumns
                            : LedgerColumns,
                        data:
                          (ReportsStore.ledgerReportFilter.reportType ===
                          "snapshot"
                            ? ReportsStore.ledgerSnapshotRawData
                            : ReportsStore.ledgerDetailedViewTableData) || [],
                      });
                    } finally {
                      setIsDownloading(false);
                      //setNiftyMenu(false);
                    }
                  }}
                  buttonProps={{
                    buttonType: "reportExport",
                  }}
                  popupClassName={{
                    open: "clicked-hover",
                    close: "",
                    wrapperClass: "popup_menu_container",
                    containerClass: "downloadPdf",
                  }}
                  restrictHover={true}
                  itemRefs={exportItemRefs}
                  menuItems={exportDataMenu}
                  accessibilityValues={{
                    buttonId: "export-dropdown",
                    ariaHaspopup: "menu",
                    ariaControls: "extract-menu",
                    ariaLabel: "Extract Data",
                  }}
                >
                  <>
                    {isDownloading && (
                      <div className="popup_downloader">
                        <img src={loaderGIF} alt="img" />
                      </div>
                    )}
                  </>
                </ExportReportList>
              </div>
            </div>
            <div className="reports_yellow_container ledger_report">
              {reportType === "snapshot" ? (
                <div className="ledger__filter-selection">
                  <div className="ledger__first-container">
                    <div className="time_period_container">
                      <RadioGroup
                        heading="Time Period"
                        name="time_period"
                        radioBtnArray={ledgertimePeriodRadioBtnsData}
                        handleChange={handleTimePeriodChange}
                        value={timePeriod}
                        radioBtnsPerRow={4}
                        groupId={"ledger-time-period1"}
                        groupName={"ledger-radio-group1"}
                      />
                      <DatePicker2
                        timePeriod={timePeriod}
                        fromDate={
                          fromDate
                            ? fromDate
                            : convertDateToObj(getCookie("asOfDate"))
                        }
                        toDate={
                          toDate
                            ? toDate
                            : convertDateToObj(getCookie("asOfDate"))
                        }
                        setFromDate={setFromDate}
                        setToDate={setToDate}
                        resetedFromDate={resetedFromDate}
                        resetedToDate={resetedToDate}
                        initialFromDate={initialFromDate}
                        initialToDate={initialToDate}
                        handleReset={handleTimePeriodReset}
                        //isActive={timePeriod === "custom"}
                        isActive={true}
                        open={datePickerModalOpen}
                        setOpen={() => {
                          handleTimePeriodChange("custom");
                          setDatePickerModalOpen(true);
                        }}
                        onClose={() => setDatePickerModalOpen(false)}
                        minDate={
                          new Date("2013-04-01").getTime() >
                          new Date(UserStore.forReportsInceptionDate).getTime()
                            ? "2013-04-01"
                            : UserStore.forReportsInceptionDate
                        }
                      />
                    </div>
                  </div>
                  <div className="ledger__second-container">
                    <div className="report_type_radio extra-padding">
                      <RadioGroup
                        heading="Report Type"
                        name="report_type"
                        radioBtnArray={ledgerReportTypeBillsData}
                        handleChange={handleReportTypeChange}
                        value={reportType}
                        radioBtnsPerRow={2}
                        groupId={"ledger-report-type-snapshot"}
                        groupName={"ledger-radio-group2"}
                      />
                    </div>
                    <div className="dropdown_wrapper">
                      <DropdownWithOptions
                        heading={
                          selectedAccount?.account_Name
                            ? selectedAccount.account_Name
                            : "Loading..."
                        }
                        headingValue={selectedAccount}
                        setHeadingValue={(data) => setSelectedAccount(data)}
                        position={{ top: "56px", left: "0px" }}
                        showPopup={!(getAccountsList()?.length === 1)}
                        showArrow={false}
                        isDisabled={!selectedAccount?.account_Name}
                        popupClassName={{
                          wrapperClass: "popup_menu_container",
                          dropDownContainerClass: "all_accounts_dropdown",
                          popupMenuClass: "",
                        }}
                        restrictHover={true}
                        OPTIONS={getAccountsList()}
                        accessibilityValues={{
                          buttonId: "",
                          ariaHaspopup: "listbox",
                          ariaControls: "accounts-options",
                          ariaLabel: "Accounts Selection",
                        }}
                        dataKey="account_Code"
                        dataValueKey="account_Name"
                      />
                      <div className="segment_menu_dropdown">
                        <DropdownWithOptions
                          heading={selectedSegment.title}
                          headingValue={selectedSegment}
                          setHeadingValue={(data) => setSelectedSegment(data)}
                          position={{ top: "56px", left: "0px" }}
                          showArrow={false}
                          popupClassName={{
                            wrapperClass: "popup_menu_container",
                            dropDownContainerClass: "all_accounts_dropdown",
                            popupMenuClass: "",
                          }}
                          restrictHover={true}
                          OPTIONS={segmentsData}
                          accessibilityValues={{
                            buttonId: "",
                            ariaHaspopup: "listbox",
                            ariaControls: "segment-options",
                            ariaLabel: "Segment Selection",
                          }}
                          dataKey="id"
                          dataValueKey="title"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="ledger__filter-selection">
                  <div className="ledger__first-container">
                    <div className="time_period_container">
                      <RadioGroup
                        heading="Time Period"
                        name="time_period"
                        radioBtnArray={
                          ledgertimePeriodRadioBtnsDataDetailedView
                        }
                        handleChange={handleTimePeriodChange}
                        value={timePeriod}
                        radioBtnsPerRow={4}
                        groupId={"ledger-time-period2"}
                        groupName={"ledger-radio-group3"}
                      />
                      <DatePicker2
                        timePeriod={timePeriod}
                        fromDate={fromDate}
                        toDate={toDate}
                        setFromDate={setFromDate}
                        setToDate={setToDate}
                        resetedFromDate={resetedFromDate}
                        resetedToDate={resetedToDate}
                        initialFromDate={initialFromDate}
                        initialToDate={initialToDate}
                        handleReset={handleTimePeriodReset}
                        isActive={true}
                        open={datePickerModalOpen}
                        setOpen={() => {
                          handleTimePeriodChange("custom");
                          setDatePickerModalOpen(true);
                        }}
                        onClose={() => setDatePickerModalOpen(false)}
                        minDate={
                          new Date("2013-04-01").getTime() >
                          new Date(UserStore.forReportsInceptionDate).getTime()
                            ? "2013-04-01"
                            : UserStore.forReportsInceptionDate
                        }
                      />
                    </div>
                  </div>
                  <div className="ledger__second-container">
                    <div className="report_type_radio extra-padding">
                      <RadioGroup
                        heading="Report Type"
                        name="report_type"
                        radioBtnArray={ledgerReportTypeBillsData}
                        handleChange={handleReportTypeChange}
                        value={reportType}
                        radioBtnsPerRow={2}
                        groupId={"ledger-report-type-snapshot2"}
                        groupName={"ledger-radio-group4"}
                      />
                    </div>
                    <div className="dropdown_wrapper">
                      <DropdownWithOptions
                        heading={selectedAccount.account_Name}
                        headingValue={selectedAccount}
                        setHeadingValue={(data) => setSelectedAccount(data)}
                        position={{ top: "56px", left: "0px" }}
                        showPopup={!(getAccountsList()?.length === 1)}
                        showArrow={false}
                        //   isDisabled={!selectedAccount?.account_Name}
                        popupClassName={{
                          wrapperClass: "popup_menu_container",
                          dropDownContainerClass: "all_accounts_dropdown",
                          popupMenuClass: "",
                        }}
                        restrictHover={true}
                        OPTIONS={getAccountsList()}
                        accessibilityValues={{
                          buttonId: "",
                          ariaHaspopup: "listbox",
                          ariaControls: "accounts-options",
                          ariaLabel: "Accounts Selection",
                        }}
                        dataKey="account_Code"
                        dataValueKey="account_Name"
                      />

                      <DropdownWithOptions
                        heading={selectedSegment.title}
                        headingValue={selectedSegment}
                        setHeadingValue={(data) => setSelectedSegment(data)}
                        position={{ top: "56px", left: "0px" }}
                        showArrow={false}
                        popupClassName={{
                          wrapperClass: "popup_menu_container",
                          dropDownContainerClass: "all_accounts_dropdown",
                          popupMenuClass: "",
                        }}
                        restrictHover={true}
                        OPTIONS={segmentsData}
                        accessibilityValues={{
                          buttonId: "",
                          ariaHaspopup: "listbox",
                          ariaControls: "segment-options",
                          ariaLabel: "Segment Selection",
                        }}
                        dataKey="id"
                        dataValueKey="title"
                      />
                    </div>
                  </div>
                </div>
              )}
              <ApplyFilter
                customCss="reusable-button"
                onApplyFilter={onApplyFilter}
                onClearFilter={onClearFilter}
              />
            </div>{" "}
            {ReportsStore.tableDataLoader ? (
              <div className="report_table_loader">
                <div className="report_loader_wrapper">
                  <img
                    className="loading_gif"
                    src={loaderGIF}
                    alt="loading..."
                  />
                </div>
              </div>
            ) : (
              <>
                {ReportsStore.ledgerReportFilter.reportType === "snapshot" && (
                  <>
                    {ReportsStore.forLedgerNoDataScreen &&
                    ReportsStore.forLedgerNoDataScreen !== 0 ? (
                      <div className="particulars_bg">
                        <div className="particulars_container">
                          {ReportsStore.ledgerSnapshotData?.map(
                            (particular, index) => (
                              <div className="each_particular_container">
                                <div
                                  className={`each_particular_heading ${
                                    index === 0 ? "header_sticky" : ""
                                  }`}
                                >
                                  <p>{particular.title}</p>
                                  <p>{particular.rightTitle}</p>
                                </div>
                                <div className="each_particular_content">
                                  {particular.contentData.length ? (
                                    <ul className="particular_details_wrapper">
                                      {particular.contentData.map((content) => (
                                        <li className="particular_detail_listitem">
                                          <p
                                            className="particular_detail_listitem_heading ledger_report_btn_animation"
                                            onClick={() => {
                                              ReportsStore.UpdateledgerSnapshotAssetModalTableDataLoader(
                                                true,
                                              );
                                              ReportsStore.getLedgerSnapShotSummary(
                                                `${fromDate?.date}/${fromDate?.month}/${fromDate?.year}`,
                                                `${toDate?.date}/${toDate?.month}/${toDate?.year}`,
                                                content.assetKey,
                                              );
                                              setSnapshotModalOpen(true);
                                              setSnapshotModalHeader(
                                                content.heading,
                                              );
                                            }}
                                          >
                                            {content.heading}
                                          </p>
                                          <p className="particular_detail_listitem_value">
                                            {content.value
                                              ? `${commaSeperated2(
                                                  content.value,
                                                )}`
                                              : "-"}
                                          </p>
                                        </li>
                                      ))}
                                    </ul>
                                  ) : null}
                                </div>
                              </div>
                            ),
                          )}
                        </div>

                        <ul className="notes blueTextColor">
                          <li>
                            <span></span>
                            Cash Segment includes Equity Cash + Debt
                          </li>
                          <li>
                            <span></span>
                            F&O Segment includes Equity F&O Currency F&O
                          </li>
                          <li>
                            <span></span>
                            Other charges include Delayed payment charges, DP
                            charges and AMC, etc
                          </li>
                          <li>
                            <span></span>
                            Statements are available for Nuvama Wealth and
                            Investment Ltd. accounts only
                          </li>
                        </ul>
                      </div>
                    ) : (
                      <div className="empty_state_for_valuation">
                        <EmptyDerivatives
                          image={emptyIcon}
                          message="You do not have any records to display"
                        />
                      </div>
                    )}
                  </>
                )}
                {ReportsStore.ledgerReportFilter.reportType ===
                  "detailed_view" && (
                  <>
                    {ReportsStore.tableDataLoader &&
                    !ReportsStore.ledgerDetailedViewTableData?.length ? (
                      <div className="report_table_loader">
                        <div className="report_loader_wrapper">
                          {}
                          <img
                            className="loading_gif"
                            src={loaderGIF}
                            alt="loading..."
                          />
                        </div>
                      </div>
                    ) : !ReportsStore.tableDataLoader &&
                      ReportsStore.ledgerDetailedViewTableData?.length ? (
                      <>
                        <Table3
                          data={vertualRows}
                          columns={LedgerColumns}
                          tableClass="ledger_report_table grey-border-table"
                          handleSort={handleSortForDetailed}
                          sortKey={filteredColumn}
                          isAscending={isAscendingForHeader}
                        />
                        <ul className="notes blueTextColor">
                          <li>
                            <span></span>
                            Cash Segment includes Equity Cash + Debt
                          </li>
                          <li>
                            <span></span>
                            F&O Segment includes Equity F&O + Currency F&O
                          </li>
                          <li>
                            <span></span>
                            Other charges include Delayed payment charges, DP
                            charges and AMC, etc
                          </li>
                          <li>
                            <span></span>
                            Statements are available for Nuvama Wealth and
                            Investment Ltd. accounts only
                          </li>
                        </ul>
                      </>
                    ) : (
                      <div className="empty_state_for_valuation">
                        <EmptyDerivatives
                          image={emptyIcon}
                          message="You do not have any records to display"
                        />
                      </div>
                    )}
                  </>
                )}
              </>
            )}
          </div>
          <Modal
            onClose={() => {
              setSnapshotModalOpen(false);
              setSnapshotModalRowData([]);
              ReportsStore.ledgerSnapshotAssetModalTableData = [];
              setKeyForOrdering({ key1: "date" }, false);
            }}
            open={snapshotModalOpen}
            width="869px"
            minWidth="869px"
            modalContainerClass="snapshot_modal_container"
          >
            <SnapshotModalContent />
          </Modal>{" "}
          {/* <PdfTable
            headerName={
              ReportsStore.ledgerReportFilter.reportType === "snapshot"
                ? "Ledger - Snapshot Report"
                : "Ledger - Detailed view Report"
            }
            columns={
              ReportsStore.ledgerReportFilter.reportType === "snapshot"
                ? LedgerSnapshotColumns
                : LedgerColumns
            }
            familyOrClientName={selectedAccount.account_Name}
            data={
              (ReportsStore.ledgerReportFilter.reportType === "snapshot"
                ? ReportsStore.ledgerSnapshotRawData
                : ReportsStore.ledgerDetailedViewTableData) || []
            }
            id={ledgerReportId}
          /> */}
        </>
      )}
    </div>
  );
});

export default LedgerReport;
